
import sharedMutations from "@/store/utils/shared-mutations";
import { Club } from "@/models";

const SET_FAVOURITE = (state, clubId) => {
  const club = state.clubs.find(club => club["Id"] === clubId);
  state.clubs.splice(
    state.clubs.indexOf(club),
    1,
    new Club({ ...club, favC: true })
  );
};

const UNSET_FAVOURITE = (state, clubId) => {
  const club = state.clubs.find(club => club["Id"] === clubId);
  state.clubs.splice(
    state.clubs.indexOf(club),
    1,
    new Club({ ...club, favC: false })
  );
};

const REMOVE_VIDEOS_MUTATION = (state, params) => {
  const video = state.videos.find(video => video._id === params.id)
  state.videos.splice(state.videos.indexOf(video), 1)
}

export default {
  ...sharedMutations,
  SET_FAVOURITE,
  UNSET_FAVOURITE,
  REMOVE_VIDEOS_MUTATION,
};
